import React, { useMemo, useRef } from "react";

import {
  getPreviewItemRendererStyle,
  showItemTitle,
} from "../../../utils/fast";

import type { Truncated } from "okast-timeline";
import type { JSX } from "react";

import type { MediaLibraryDragItem } from "../../../types";

interface TemplateDropZoneItemRendererProps {
  itemDrag: MediaLibraryDragItem;
  startPosition: number;
  size: number;
  isVertical: boolean;
  dropZoneSize: number;
  truncated: Truncated;
  truncatedDropzone: Truncated;
}

function TemplateDropZoneItemRenderer({
  itemDrag,
  startPosition,
  size,
  isVertical,
  dropZoneSize,
  truncated,
  truncatedDropzone,
}: TemplateDropZoneItemRendererProps): JSX.Element {
  const previewRef = useRef<HTMLDivElement>(null);

  const previewItemStyle = useMemo(
    () =>
      getPreviewItemRendererStyle({
        size,
        startPosition,
        isVertical,
        color: itemDrag.color,
        truncated,
        truncatedDropzone,
      }),
    [
      size,
      startPosition,
      isVertical,
      itemDrag.color,
      truncated,
      truncatedDropzone,
    ],
  );

  const previewElementSize = previewRef.current?.getBoundingClientRect();

  const displayTitle = showItemTitle({ isVertical, size });

  const middleDropZone = (dropZoneSize - 12) / 2;

  // todo preview item à revoir problème avec le truncate du titre et afficher le start et end time
  return (
    <div
      ref={previewRef}
      className="pointer-events-none absolute rounded-[6px]"
      data-testid="preview-media-schedule-item"
      id="preview-media-schedule-item"
      style={previewItemStyle}
    >
      {displayTitle ? (
        <div
          className="p-[0.46875rem]"
          style={{
            marginTop: `-${middleDropZone}px`,
            height: previewElementSize?.height,
          }}
        >
          <span className="font-semibold">{itemDrag?.label}</span>
        </div>
      ) : null}
    </div>
  );
}

export default TemplateDropZoneItemRenderer;
